import axios from 'axios';

const BACKEND = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

const api = axios.create({
  baseURL: `${BACKEND}/api`,
  withCredentials: true,
});

export const mediaUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('/api/')) return `${BACKEND}${url}`;
  return url;
};

export const apiError = (e) => {
  const detail = e?.response?.data?.detail;
  if (detail == null) return 'Bir hata oluştu. Lütfen tekrar deneyin.';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map((x) => (x && typeof x.msg === 'string' ? x.msg : JSON.stringify(x))).join(' ');
  if (detail && typeof detail.msg === 'string') return detail.msg;
  return String(detail);
};

let refreshWait = null;

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const detail = err?.response?.data?.detail;
    if (err?.response?.status === 403 && typeof detail === 'string' && detail.includes('Telegram')) {
      window.dispatchEvent(new Event('telegram-bind-required'));
    }
    const cfg = err?.config || {};
    const url = String(cfg.url || '');
    const skip = cfg._retry || url.includes('/auth/login') || url.includes('/auth/refresh') || url.includes('/auth/logout') || url.includes('/auth/forgot-password') || url.includes('/auth/reset-password');
    if (err?.response?.status === 401 && !skip) {
      cfg._retry = true;
      try {
        refreshWait = refreshWait || api.post('/auth/refresh');
        await refreshWait;
        refreshWait = null;
        return api(cfg);
      } catch (e) {
        refreshWait = null;
      }
    }
    return Promise.reject(err);
  },
);

export default api;
